<template>
  <div class="zv-page">
    <div class="zv-content">
      <div class="zv-block">
        <div
          class="cd-search-form-wrap"
          :class="showMoreSearch ? 'style-show-more' : 'style-hide-more'"
        >
          <el-form
            ref="searchForm"
            :model="searchFormData"
            class="cd-search-form"
            label-width="80px"
          >
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="文章ID:" prop="area_id_arr">
                  <el-input
                    placeholder="输入文章ID"
                    v-model="searchFormData.id"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="所属分类:" prop="cat_id">
                  <el-select
                    placeholder="请选择"
                    v-model="searchFormData.cat_id"
                    clearable
                  >
                    <el-option
                      v-for="item in $enums.CollectSourceType.list"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="文章标题:" prop="title">
                  <el-input
                    placeholder="请输入文章标题"
                    v-model="searchFormData.title"
                  ></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="6">
                <el-form-item label="审核状态:" prop="status">
                  <el-select
                    placeholder="请选择"
                    v-model="searchFormData.status"
                    clearable
                  >
                    <el-option
                      v-for="item in publishList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="风险等级:" prop="risk_level">
                  <el-select
                    placeholder="请选择"
                    v-model="searchFormData.risk_level"
                    clearable
                  >
                    <el-option
                      v-for="item in riskList"
                      :key="item.label"
                      :label="item.label"
                      :value="item.label"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
               <el-col :span="9">
                <el-form-item label="发布时间">
                  <el-date-picker
                    v-model="searchFormData.value1"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item label="发生时间">
                  <el-date-picker
                    v-model="searchFormData.value1"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="发生地区:" prop="area_id">
                  <el-select
                    placeholder="请选择"
                    v-model="searchFormData.area_id"
                    clearable
                  >
                    <el-option
                      v-for="item in areaList"
                      :key="item.id"
                      :label="item.area_name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="发布人:" prop="create_admin_id">
                  <el-select
                    placeholder="请选择"
                    v-model="searchFormData.create_admin_id"
                    clearable
                  >
                    <el-option
                      v-for="item in $enums.CollectSourceType.list"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
           
            <el-form-item style="text-align: right;">
              <el-button type="primary" @click="getCDQueryData">查询</el-button>
              <el-button type="danger">导出</el-button>
              <!-- <el-button type="info" @click="resetQueryClick">重置</el-button> -->
            </el-form-item>
          </el-form>
        </div>
        <div class="show-more-toggle-wrapper">
          <div class="show-more-toggle-btn" @click="toggleShowMore">
            <i
              :class="
                showMoreSearch ? 'el-icon-arrow-up' : 'el-icon-arrow-down'
              "
            ></i>
            <span>{{ showMoreSearch ? "收起筛选条件" : "展开筛选条件" }}</span>
          </div>
        </div>

        <div class="batch" style="margin-bottom: 10px">
          <el-button type="primary" @click="batchHandle">添加专题</el-button>
        </div>
        <!-- @on-selection-change="handleSelectionChange" -->
        <zv-table :table="table" ref="dataTable"></zv-table>
      </div>
    </div>
  </div>
</template>
<script>
import api from "./api";
import addFormMixin from "@/mixins/addFormMixin";
import formPageMixin from "@/mixins/formPageMixin";
import TipUtil from "@/utils/utils/TipUtil";
export default {
  name: "listofTopics",
  mixins: [addFormMixin, formPageMixin],
  components: {},
  data() {
    let vm = this;
    return {
      // 查询条件ori
      selectLen: '',
      batchIds: "",
      publishList: [
        { label: '正常', value: 1},
        { label: '待审核', value: 2},
        { label: '删除', value: 0}
      ],
      riskList: [
        { label: '潜在风险'},
        { label: '轻微风险'},
        { label: '严重风险'},
        { label: '恶劣风险'},
        { label: '极度恶劣风险'}
      ],
      showMoreSearch: false,
      searchFormData: {},
      publish_time_begin_str: "",
      publish_time_end_str: "",
      add_time_begin_str: "",
      add_time_end_str: "",
      areaList: [], // 国家数组
      languageList: [], // 语言列表
      sourceList: [], // 信息源列表
      selectTagValue: "", // 下拉选择选中的tag值
      selectTagsList: [], // 所有tag 列表
      keywordsTypes: [
        {
          label: "标题",
          value: 1
        },
        {
          label: "内容",
          value: 2
        }
      ],
      table: {
        api: api.articleSpecialList,
        query: {},
        columns: [
          {
            title: "标题",
            key: "title",
            minWidth: "150",
            showTooltip: true
          },
          {
            title: "事件相关",
            key: "category_name",
            minWidth: "200",
            render(h, ctx) {
              const type = h(
                "p",
                "事件类别：" + ctx.row.article_event_category_name
              );
              const level = h(
                "p",
                "风险等级：" + ctx.row.risk_level
              );
              const time1 = h(
                "p",
                "发生时间：" + vm.$commFunc.formatDate(ctx.row.event_occurred_time)
              );
              const time2 = h(
                "p",
                "最新进展：" + vm.$commFunc.formatDate(ctx.row.update_time)
              );
              const area = h(
                "p",
                "地区：" + ctx.row.full_area_name
              );
              const address = h(
                "p",
                "地点：" + ctx.row.address
              );
              let arr = [];
              arr.push(type);
              arr.push(level);
              arr.push(time1);
              arr.push(time2);
              arr.push(area);
              arr.push(address);
              return h("span", arr);
            }
          },
          {
            title: "伤亡人数",
            minWidth: "160",
            render(h, ctx) {
              const type = h(
                "p",
                "死亡人数：" + ctx.row.death_num
              );
              const level = h(
                "p",
                "受伤人数：" + ctx.row.injured_num
              );
              const time1 = h(
                "p",
                "涉华死亡人数：" + ctx.row.chinese_death_num
              );
              const time2 = h(
                "p",
                "涉华受伤人数：" + ctx.row.chinese_injured_num
              );
              
              let arr = [];
              arr.push(type);
              arr.push(level);
              arr.push(time1);
              arr.push(time2);
              return h("span", arr);
            }
          },
          {
            title: "浏览/评论数",
            minWidth: "90",
            render(h, ctx) {
              return h("span", ctx.row.view_count+"/"+ctx.row.comment_count);
            }
          },
          {
            title: "发布信息",
            minWidth: "150",
            render(h, ctx) {
              console.log(ctx.row.status)
              const type = h(
                "p",
                "状态：" + ctx.row.status == 1 ? "正常": ctx.row.status == 2 ? "待审核": ctx.row.status == 0 ? "删除":""
              );
              const level = h(
                "p",
                "发布人：" + ctx.row.create_username
              );
              const time1 = h(
                "p",
                vm.$commFunc.formatDate(ctx.row.add_time)
              );
              let arr = [];
              arr.push(type);
              arr.push(level);
              arr.push(time1);
              return h("span", arr);
            }
          },
          {
            title: "最后操作人",
            minWidth: "140",
            render(h, ctx) {
              const level = h(
                "p",
                ctx.row.last_admin_username
              );
              const time1 = h(
                "p",
                vm.$commFunc.formatDate(ctx.row.last_admin_time)
              );
              let arr = [];
              arr.push(level);
              arr.push(time1);
              return h("span", arr);
            }
          },
          {
            title: "操作",
            fixed: "right",
            minWidth: "50",
            render(h, ctx) {
              const editBtn = h(
                "el-button",
                {
                  attrs: {
                    type: "text"
                  },
                  on: {
                    click: vm.doViewDetail.bind(this, ctx.row.id)
                  }
                },
                "编辑"
              );
              let arr = [];
              arr.push(editBtn);
              return h("span", arr);
            }
          }
        ],
      },
      formDataOri: {
        app_name: ""
      },
      formRules: {
        app_name: [
          {
            required: true,
            message: "App名称不能为空",
            trigger: "blur"
          }
        ]
      },
      deleteApi: api.editCollectData,
      deleteSuccessMsg: "删除文章成功"
    };
  },

  methods: {
    async getCDQueryData() {
      this.$set(this.table, "query", this.searchFormData);
      this.$refs.dataTable.refresh();
      
    },

    async getAreaList() {
      this.areaList = await this.$commFunc.getAreaList({
        // area_type: 2
      });
    },

    // handleSelectionChange() {
    //   this.searchFormData = this.$_.cloneDeep(this.searchFormDataOri);
    //   this.$refs.searchForm.resetFields();
    //   this.publish_time_begin_str = "";
    //   this.publish_time_end_str = "";
    //   this.add_time_begin_str = "";
    //   this.add_time_end_str = "";
    // },

    toggleShowMore() {
      this.showMoreSearch = !this.showMoreSearch;
    },


    // 添加专题
    batchHandle() {
      let routeData = this.$router.resolve("/data-input/listofTopicsDetails");
      window.open(routeData.href, '_blank');
    },
    doViewDetail(id) {
      let routeData = this.$router.resolve("/data-input/listofTopicsDetails?id=" + id);
      window.open(routeData.href, '_blank');
    }
  },

  created() {
    // this.getCDQueryData();
    this.getAreaList();
    // this.getLanguageList();
    // this.getSourceList();
    // this.getCollectSourceTagList();
  },

  mounted() {},
  beforeDestroy() {}
};
</script>

<style lang="less" scoped>
.cd-search-form-wrap {
  position: relative;
  overflow: hidden;
  &.style-hide-more {
    height: 40px;
  }
}

.show-more-toggle-wrapper {
  display: flex;
  justify-content: center;
  padding: 5px 0 15px;
}
.show-more-toggle-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  color: #999;
  font-size: 12px;
  i {
    margin-right: 5px;
  }
}
.cd-search-form {
  .el-form-item {
    margin-bottom: 10px;
  }

  .cdd-status-sec2 {
    display: flex;
  }

  .cdd-status-sec22 {
    margin-right: 5px;
    .el-tag + .el-tag {
      margin-left: 5px;
    }
  }
}
</style>
